import React from 'react';

function SkeletonCard() {
  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-md p-4 flex flex-col items-center gap-2 w-40 animate-pulse">
      <div className="w-16 h-16 rounded-full bg-gray-200" />
      <div className="w-24 h-3 bg-gray-200 rounded" />
      <div className="w-16 h-2 bg-gray-100 rounded" />
      <div className="w-12 h-2 bg-gray-100 rounded" />
    </div>
  );
}

export default function OrgChartSkeleton() {
  return (
    <div className="flex flex-col items-center gap-8 py-8">
      <div className="flex justify-center">
        <SkeletonCard />
      </div>
      <div className="flex justify-center gap-6">
        {[1, 2, 3].map(i => <SkeletonCard key={i} />)}
      </div>
      <div className="flex justify-center gap-4">
        {[1, 2, 3, 4, 5].map(i => <SkeletonCard key={i} />)}
      </div>
    </div>
  );
}
